const entryTime = (entry = {}) => new Date(entry.launchDate || entry.createdAt || 0).getTime() || 0;

const normalizeStatus = (status) => {
  if (status === 'started') return 'in_progress';
  if (['in_progress', 'paused', 'awaiting_send', 'awaiting_receive', 'completed', 'other'].includes(status)) return status;
  return 'other';
};

export const getDerivedBusinessStatus = (progressList = []) => {
  const items = Array.isArray(progressList) ? progressList.filter(Boolean) : [];
  if (!items.length) return 'other';
  if (items.every((item) => item.status === 'completed')) return 'completed';

  return normalizeStatus([...items].sort((a, b) => entryTime(b) - entryTime(a))[0]?.status);
};

export const PROGRESS_STATUS_KEYS = [
  'in_progress',
  'paused',
  'awaiting_send',
  'awaiting_receive',
  'completed',
  'other',
];
